import { render, staticRenderFns } from "./HistoryBewertungen.vue?vue&type=template&id=6f50934c&scoped=true&"
import script from "./HistoryBewertungen.vue?vue&type=script&lang=js&"
export * from "./HistoryBewertungen.vue?vue&type=script&lang=js&"
import style0 from "./HistoryBewertungen.vue?vue&type=style&index=0&id=6f50934c&prod&lang=css&"
import style1 from "./HistoryBewertungen.vue?vue&type=style&index=1&id=6f50934c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f50934c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VList } from 'vuetify/lib/components/VList';
import { VListGroup } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardTitle,VCol,VDataTable,VList,VListGroup,VListItem,VListItemContent,VProgressCircular,VRow,VSelect,VTextField})
